<svg
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16 0H2C0.897 0 0 0.897 0 2V16C0 17.103 0.897 18 2 18H16C17.103 18 18 17.103 18 16V2C18 0.897 17.103 0 16 0ZM8.067 13.481L4.293 9.707L5.707 8.293L7.933 10.519L12.232 5.36L13.769 6.64L8.067 13.481Z"
    fill="currentColor"
  />
</svg>
